import styled from "styled-components"

const Section = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`

export {
    Section
}